export const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';
export const BLACK_SCREEN_SESSION_STORAGE_KEY = 'iosUpload';
export const UTM_PARAMS_SESSION_STORAGE_KEY = 'utmParams';
